export const shapePatterns: { [key: string]: string[] } = {
    square: [
        '*****',
        '*****',
        '*****',
        '*****',
        '*****'
    ],
    'hollow square': [
        '*****',
        '*   *',
        '*   *',
        '*   *',
        '*****',
    ],
    'right triangle': [
        '    *',
        '   **',
        '  ***',
        ' ****',
        '*****',
    ],
    'left triangle': [
        '*',
        '**',
        '***',
        '****',
        '*****',
    ],
    'downward triangle': [
        '*****',
        '****',
        '***',
        '**',
        '*',
    ],
    'hollow triangle': [
        '*',
        '**',
        '* *',
        '*  *',
        '*   *',
        '******',
    ],
    pyramid: [
        '    *',
        '   ***',
        '  *****',
        ' *******',
        '*********',
    ],
    'reversed pyramid': [
        '*********',
        ' *******',
        '  *****',
        '   ***',
        '    *',
    ],
    'hollow pyramid': [
        '    *',
        '   * *',
        '  *   *',
        ' *     *',
        '*********',
    ],
    diamond: [
        '    *',
        '   ***',
        '  *****',
        ' *******',
        '*********',
        ' *******',
        '  *****',
        '   ***',
        '    *',
    ],
    'hollow diamond': [
        '    *',
        '   * *',
        '  *   *',
        ' *     *',
        '*       *',
        ' *     *',
        '  *   *',
        '   * *',
        '    *',
    ],
    hourglass: [
        '*********',
        ' *******',
        '  *****',
        '   ***',
        '    *',
        '   ***',
        '  *****',
        ' *******',
        '*********',
    ],
    heart: [
        '  ***   ***  ',
        ' ***** ***** ',
        ' *********** ',
        '  *********  ',
        '   *******   ',
        '    *****    ',
        '     ***     ',
        '      *      '
    ],
    circle: [
        '   ***   ',
        ' *     * ',
        '*       *',
        '*       *',
        ' *     * ',
        '   ***   '
    ],
    oval: [
        '   *****   ',
        ' **     ** ',
        '*         *',
        ' **     ** ',
        '   *****   '
    ],
    cross: [
        '    *    ',
        '    *    ',
        '*********',
        '    *    ',
        '    *    '
    ],
    plus: [
        '    *    ',
        '    *    ',
        ' ******* ',
        '    *    ',
        '    *    '
    ],
    star: [
        '    *    ',
        '   * *   ',
        '  *****  ',
        ' * *** * ',
        '*   *   *'
    ],
    arrow: [
        '    *    ',
        '   ***   ',
        '  *****  ',
        '    *    ',
        '    *    ',
        '    *    '
    ],
    'right arrow': [
        '*    ',
        '**   ',
        '***  ',
        '**** ',
        '*****',
        '**** ',
        '***  ',
        '**   ',
        '*    '
    ],
    'left arrow': [
        '    *',
        '   **',
        '  ***',
        ' ****',
        '*****',
        ' ****',
        '  ***',
        '   **',
        '    *'
    ],
    pentagon: [
        '   ***   ',
        '  *   *  ',
        ' *     * ',
        '*       *',
        '*********'
    ],
    hexagon: [
        '   ****   ',
        '  *    *  ',
        ' *      * ',
        '  *    *  ',
        '   ****   '
    ],
    octagon: [
        '  ******  ',
        ' *      * ',
        '*        *',
        '*        *',
        ' *      * ',
        '  ******  '
    ],
    'hollow circle': [
        '   ***   ',
        ' *     * ',
        '*       *',
        '*       *',
        ' *     * ',
        '   ***   '
    ],
    'infinity': [
        '  **   **  ',
        ' *  * *  * ',
        '  *  *  *  ',
        ' *  * *  * ',
        '  **   **  '
    ],
    'wave': [
        '~    ~    ',
        ' ~  ~ ~  ~',
        '  ~~   ~~ '
    ],
    'arrow up': [
        '    *    ',
        '   ***   ',
        '  *****  ',
        '    *    ',
        '    *    ',
        '    *    '
    ],
    'arrow down': [
        '    *    ',
        '    *    ',
        '    *    ',
        '  *****  ',
        '   ***   ',
        '    *    '
    ]
};
